import {
  Box,
  Button,
  Chip,
  Container,
  Grid,
  InputAdornment,
  Modal,
  Paper,
  Switch,
  TextField,
  Toolbar,
  Typography,
} from '@mui/material';
import Dashboard from '../../../../components/Admin/Dashboard';
import { Styles } from '../../../../styles/global';
import { useEffect, useRef, useState } from 'react';
import { getAvailableYears, getProjects } from '../../../../utils/API';
import { useSearchParams } from 'react-router-dom';
import Filters from '../../../../components/Filters';
import projectsFiltersSchema from '../../../../utils/FiltersSchema/AdminProjects';
import ProjectsView from '../../../../components/Views';
import { IconButton } from '@mui/material';
import ListIcon from '@mui/icons-material/List';
import TableViewIcon from '@mui/icons-material/TableView';
import { DataGrid, GridSearchIcon } from '@mui/x-data-grid';
import { Check, Close, Group, Scoreboard } from '@mui/icons-material';
import { useAuth } from '../../../../utils/AuthContext';

function Projects() {
  const [projects, setProjects] = useState([]);
  const [years, setYears] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const topRef = useRef(null); // Create a ref for the top of the page
  const [viewMode, setViewMode] = useState('list'); // Default view mode

  const [tableProjects, setTableProjects] = useState([]);

  const [showTableFilters, setShowTableFilters] = useState(false);

  const toggleViewMode = () => {
    setViewMode((prevMode) => (prevMode === 'list' ? 'table' : 'list'));
  };
  useEffect(() => {
    if (
      !searchParams.get('search') ||
      searchParams.get('search') !== 'projects'
    ) {
      setSearchParams('search=projects');
    }
    if (!searchParams.get('limit')) {
      setSearchParams(`${searchParams.toString()}&limit=10`);
    }
    if (!searchParams.get('page')) {
      setSearchParams(`${searchParams.toString()}&page=1`);
    }
    if (!searchParams.get('year')) {
      setSearchParams(
        `${searchParams.toString()}&year=${new Date().getFullYear()}`
      );
    }
    searchParams.delete('type');
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    async function fetchAvailableYears() {
      try {
        const yearsResponse = await getAvailableYears(
          searchParams.get('department' || '')
        );
        const availableYears =
          yearsResponse?.data?.data?.sort(function (a, b) {
            return b - a;
          }) || [];
        setYears(availableYears.map((year) => year.toString()));
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchProjects() {
      try {
        const removeParams = ['search'];
        removeParams.forEach((param) => searchParams.delete(param));
        const projectsResponse = await getProjects(searchParams.toString());
        setProjects(projectsResponse?.data || []);
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchTableProjects() {
      try {
        const removeParams = [
          'search',
          'department',
          'course',
          'page',
          'limit',
        ];
        removeParams.forEach((param) => searchParams.delete(param));
        const projectsResponse = await getProjects(searchParams.toString());
        setTableProjects(projectsResponse?.data || []);
      } catch (error) {
        console.log(error);
      }
    }
    try {
      fetchAvailableYears();
      if (
        !searchParams.get('limit') ||
        !searchParams.get('page') ||
        !searchParams.get('search') ||
        searchParams.get('search') !== 'projects'
      ) {
        return;
      }
      fetchProjects();
      fetchTableProjects();
    } catch (error) {
      console.log(error);
    }
  }, [searchParams]);

  const { user } = useAuth();

  const [search, setSearch] = useState('');

  const columns = [
    {
      field: 'posterImage',
      headerName: '',
      width: 250,
      renderCell: (params) => (
        <img
          src={`${process.env.REACT_APP_SPACES_ENDPOINT_POSTER_IMAGES}${params?.row?.posterImage}`}
          alt={params?.row?.title}
          width={'100%'}
          // size
          style={{ borderRadius: '4px', objectFit: 'cover', cursor: 'pointer' }}
          onClick={() =>
            window.open(
              `/admin/dashboard/projects/${
                params?.row?._id
              }?year=${searchParams.get('year')}`,
              '_blank'
            )
          }
        />
      ),
      sortable: false,
      filterable: false,
    },
    {
      field: 'title',
      headerName: 'Title & Owners',
      width: 250,
      renderCell: (params) => (
        <>
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', cursor: 'pointer' }}
            onClick={() =>
              window.open(
                `/admin/dashboard/projects/${
                  params?.row?._id
                }?year=${searchParams.get('year')}`,
                '_blank'
              )
            }
            marginTop={1}
          >
            {params?.row?.title}
          </Typography>
          <Box display="flex" flexWrap="wrap">
            {params?.row?.ownersDescription.map((owner, index) => (
              <Typography
                key={index}
                variant="caption"
                fontFamily="sans-serif"
                color="gray"
                whiteSpace={'pre'}
              >
                {owner?.fullName}
                {index < params?.row.ownersDescription.length - 1 && '  •  '}
              </Typography>
            ))}
          </Box>
        </>
      ),
    },
    {
      field: 'course',
      headerName: 'Course',
      width: 100,
      renderCell: (params) => (
        <>
          <Typography variant="body2" marginTop={1}>
            {params?.row?.course}
          </Typography>
        </>
      ),
      //
      type: 'singleSelect',
      valueOptions: ['SD1', 'SD2', 'N/A', ''],
    },
    {
      field: 'department',
      headerName: 'Dept',
      width: 100,
      renderCell: (params) => (
        <>
          <Typography variant="body2" marginTop={1}>
            {params?.row?.department !== 'ME' && params.row.department}
          </Typography>
        </>
      ),
      type: 'singleSelect',
      valueOptions: ['CIS', 'ECE', 'ME', 'IMSE', 'N/A'],
    },
    {
      field: 'indicators',
      headerName: 'Indicators',
      flex: 1,
      renderCell: (params) => (
        <Box marginTop={1}>
          <Chip
            label={'Abstract'}
            color={params?.row?.abstract ? 'success' : 'error'}
            variant="outlined"
            sx={{ mb: 1, mr: 1 }}
          />
          <Chip
            label={'Poster PDF'}
            color={params?.row?.posterLink ? 'success' : 'error'}
            variant="outlined"
            sx={{ mb: 1, mr: 1 }}
          />
          {params?.row?.projectBids?.includes(user?._id) && (
            <Chip
              label={'Bid'}
              icon={<Check />}
              color={'success'}
              variant="outlined"
              sx={{ mb: 1, mr: 1 }}
            />
          )}
          {!!params?.row?.assignments?.length && user?.role === 'ADMIN' && (
            <>
              <Chip
                label={`${params?.row?.assignments?.length} Assignment${
                  params?.row?.assignments?.length > 1 ? 's' : ''
                }`}
                color="success"
                icon={<Scoreboard />}
                variant="outlined"
                sx={{ mb: 1, mr: 1 }}
              />
            </>
          )}
          {params?.row?.expectedNumberOfMembers >
            params?.row?.owners?.length && (
            <Chip
              label={`Insufficient Members: ${params?.row?.owners?.length}/${params?.row?.expectedNumberOfMembers}`}
              color="error"
              icon={<Group />}
              variant="outlined"
              sx={{ mb: 1, mr: 1 }}
            />
          )}
        </Box>
      ),
    },
  ];
  const paginationModel = { page: 0, pageSize: 10 };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    maxHeight: '55vh',
    height: '100%',
    bgcolor: '#fff',
    border: '2px solid #f0f0f0',
    borderRadius: '8px', // Rounded corners
    boxShadow: 24,
    p: 4,
  };

  const handleOpen = () => setShowTableFilters(true);
  const handleClose = () => setShowTableFilters(false);

  const [courseFilter, setCourseFilter] = useState([]);
  const [departmentFilter, setDepartmentFilter] = useState([]);
  const [indicatorsFilter, setIndicatorsFilter] = useState([]);

  const filterProjects = (initialProjects) => {
    // console.log(initialProjects);
    let filteredProjects = initialProjects || [];

    if (courseFilter?.length > 0) {
      filteredProjects = filteredProjects.filter((project) =>
        courseFilter.includes(project.course)
      );
    }

    if (departmentFilter?.length > 0) {
      filteredProjects = filteredProjects.filter((project) =>
        departmentFilter.includes(project.department)
      );
    }

    if (indicatorsFilter.length > 0) {
      filteredProjects = filteredProjects.filter((project) => {
        return indicatorsFilter.every((indicator) => {
          if (indicator === 'Missing Abstract') {
            return !project.abstract;
          } else if (indicator === 'Missing Poster') {
            return !project.posterLink;
          } else if (indicator === 'Has Judge Bids') {
            return project.projectBids?.length > 0;
          } else if (indicator === 'Members Mismatch') {
            return project.expectedNumberOfMembers > project.owners.length;
          } else if (indicator === 'Has Assignments') {
            return project.assignments && project.assignments.length > 0;
          }
          return true;
        });
      });
    }

    return filteredProjects;
  };

  function FiltersTable() {
    return (
      <>
        <Button
          variant="outlined"
          onClick={() => setShowTableFilters(!showTableFilters)}
        >
          Filter
        </Button>
        <Modal
          open={showTableFilters}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box sx={{ height: '100%' }}>
              <Box
                justifyContent={'space-between'}
                display="flex"
                alignItems="center"
                mb={2}
              >
                <Typography id="modal-modal-title" variant="h5" component="h2">
                  Filters
                </Typography>
                <Close onClick={handleClose} style={{ cursor: 'pointer' }} />
              </Box>
              <hr />

              {
                <>
                  <Typography variant="h6" fontWeight={500} mt={2} mb={1}>
                    Course
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {['SD1', 'SD2', 'N/A'].map((course) => (
                      <Chip
                        key={course}
                        label={course}
                        clickable
                        color={
                          courseFilter.includes(course) ? 'primary' : 'default'
                        }
                        variant={
                          courseFilter.includes(course) ? 'filled' : 'outlined'
                        }
                        onClick={() => {
                          if (courseFilter.includes(course)) {
                            setCourseFilter(
                              courseFilter.filter((c) => c !== course)
                            );
                          } else {
                            setCourseFilter([...courseFilter, course]);
                          }
                        }}
                      />
                    ))}
                  </Box>
                </>
              }
              {
                <>
                  <Typography variant="h6" fontWeight={500} mt={2} mb={1}>
                    Department
                  </Typography>

                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {['CIS', 'IMSE', 'ME', 'ECE', 'N/A'].map((department) => (
                      <Chip
                        key={department}
                        label={department}
                        clickable
                        color={
                          departmentFilter.includes(department)
                            ? 'primary'
                            : 'default'
                        }
                        variant={
                          departmentFilter.includes(department)
                            ? 'filled'
                            : 'outlined'
                        }
                        onClick={() => {
                          if (departmentFilter.includes(department)) {
                            setDepartmentFilter(
                              departmentFilter.filter((c) => c !== department)
                            );
                          } else {
                            setDepartmentFilter([
                              ...departmentFilter,
                              department,
                            ]);
                          }
                        }}
                      />
                    ))}
                  </Box>
                </>
              }

              {
                <>
                  <Typography variant="h6" fontWeight={500} mt={2} mb={1}>
                    Indicators
                  </Typography>

                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {[
                      'Missing Abstract',
                      'Missing Poster',
                      'Has Judge Bids',
                      'Members Mismatch',
                      'Has Assignments',
                    ].map((indicator) => (
                      <Chip
                        key={indicator}
                        label={indicator}
                        clickable
                        color={
                          indicatorsFilter.includes(indicator)
                            ? 'primary'
                            : 'default'
                        }
                        variant={
                          indicatorsFilter.includes(indicator)
                            ? 'filled'
                            : 'outlined'
                        }
                        onClick={() => {
                          if (indicatorsFilter.includes(indicator)) {
                            setIndicatorsFilter(
                              indicatorsFilter.filter((c) => c !== indicator)
                            );
                          } else {
                            setIndicatorsFilter([
                              ...indicatorsFilter,
                              indicator,
                            ]);
                          }
                        }}
                      />
                    ))}
                  </Box>
                </>
              }

              <Button
                variant="outlined"
                fullWidth
                sx={{ mt: 3 }}
                onClick={handleClose}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Modal>
      </>
    );
  }

  return (
    <>
      <Box {...Styles.mainBox}>
        <Toolbar />

        {/* Container With Max Width = lg breakpoint */}
        <Container {...Styles.customContainer('xl')}>
          {/*Outer Grid Container */}
          <Grid container spacing={3}>
            {/*Inner Grid Begins*/}

            {/*Inner Grid Item 0: Space Taken */}
            <Grid item lg={3} sm={0} xs={0} ref={topRef}>
              <div />
            </Grid>

            {/*Inner Grid Item 1: Page Title */}
            <Grid item lg={9} sm={12} xs={12} ref={topRef}>
              <Paper
                elevation={3}
                square={false}
                sx={{
                  p: 2,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexDirection: 'row',
                  overflow: 'auto',
                }}
              >
                <Typography
                  variant="h6"
                  fontSize="1.7rem"
                  color="#1976D2"
                  fontWeight={400}
                  fontFamily={"'Roboto', 'Helvetica', 'Arial', sans-serif"}
                >
                  Projects
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {viewMode === 'table' && (
                    <Box
                      gap={2}
                      sx={{ display: 'flex', alignItems: 'center', mr: 2 }}
                    >
                      <FiltersTable />
                      <TextField
                        variant="outlined"
                        placeholder="Search..."
                        size="small"
                        sx={{ width: 300 }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <GridSearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </Box>
                  )}

                  <IconButton onClick={toggleViewMode} color="primary">
                    {viewMode === 'list' ? <TableViewIcon /> : <ListIcon />}
                  </IconButton>

                  <Typography variant="body2" sx={{ mr: 2 }}>
                    {viewMode === 'list' ? 'List View' : 'Table View'}
                  </Typography>
                  <Switch
                    checked={viewMode === 'table'}
                    onChange={toggleViewMode}
                  />
                </Box>
              </Paper>
            </Grid>

            {/*Inner Grid Item 2: Filters */}
            {
              <Grid item lg={3} sm={12} xs={12}>
                <Box {...Styles.dashboardContentWidget('auto')}>
                  <Filters
                    filtersSchema={projectsFiltersSchema({
                      avaliableYears: years,
                    })}
                    searchType={'projects'}
                    disabled={viewMode === 'table'}
                  />
                </Box>
              </Grid>
            }

            {/*Inner Grid Item 3: Projects View */}
            {viewMode === 'list' ? (
              <Grid item lg={9} sm={12} xs={12}>
                <Paper {...Styles.dashboardContentMinWidget()}>
                  <ProjectsView
                    items={projects}
                    topRef={topRef}
                    link="/admin/dashboard/projects"
                    itemType={'projects'}
                  />
                </Paper>
              </Grid>
            ) : (
              <Grid item lg={9} sm={12} xs={12}>
                <Paper
                  {...Styles.dashboardContentMinWidget(
                    { lg: 340, md: 'auto' },
                    { lg: 700, md: 'auto' }
                  )}
                >
                  <div style={{ width: '100%', height: '70vh' }}>
                    <DataGrid
                      rows={filterProjects(tableProjects?.data)?.filter(
                        (project) =>
                          project.title
                            .toLowerCase()
                            .includes(search.toLowerCase()) ||
                          project.ownersDescription.some((owner) =>
                            owner.fullName
                              .toLowerCase()
                              .includes(search.toLowerCase())
                          )
                      )}
                      columns={columns}
                      initialState={{ pagination: { paginationModel } }}
                      pageSizeOptions={[10, 25, 50, 100]}
                      getRowHeight={() => 'auto'}
                      sx={{
                        border: '1px solid #ddd',
                        borderRadius: 2,
                        overflow: 'hidden',
                        '& .MuiDataGrid-columnHeaders': {
                          fontSize: '1rem',
                          fontWeight: 'bold',
                        },
                        '& .MuiDataGrid-root': {
                          backgroundColor: 'white',
                        },
                        '& .MuiDataGrid-cell': {
                          fontSize: '0.9rem',
                          borderBottom: '1px solid #eee',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                          backgroundColor: '#f4f4f4',
                        },
                        '& .MuiDataGrid-row:hover': {
                          backgroundColor: '#e3f2fd',
                        },
                      }}
                      disableSelectionOnClick
                      disableRowSelectionOnClick
                    />
                  </div>
                </Paper>
              </Grid>
            )}
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default function AdminDashboardProjects() {
  return <Dashboard Page={Projects} PageName={'(A) Dashboard - Projects'} />;
}
